import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

// parent state for all user signed in states
export const appState = {
   name: 'app',
   component: 'app',
   abstract: true,
   data: {
      roles: '*'
   }
};

// TODO: Remove instances of e360-
export const adminState = {
   parent: 'app',
   name: 'admin',
   url: '/admin',
   abstract: true,
   data: {
      roles: 'SuperAdmin,OrgAdmin',
      nav: {
         title: 'Admin',
         icon: 'e360-icon-admin',
         children: [
            { title: 'Users', stateName: 'admin.users' },
            { title: 'User Activity Logs', stateName: 'admin.activityLog' },
            { title: 'Device Usage', stateName: 'admin.deviceUsage' },
            { title: 'Transfer Status', stateName: 'admin.transferStatus' },
            {
               title: 'Survey Items',
               stateName: 'admin.surveyItems',
               otherStates: [ 'admin.validateXml' ]
            },
            { title: 'Email', stateName: 'admin.email' },
            { title: 'Advanced Search', stateName: 'admin.search' },
            { title: 'Event Search', stateName: 'admin.events' },
         ]
      }
   }
};

export const anonState = {
   name: 'anon',
   data: { allowAnon: true },
   component: 'anonShell'
}

export const loginState = {
   parent: 'anon',
   name: 'login',
   url: '/login',
   component: 'login'
};

export const termsState = {
   parent: 'anon',
   name: 'terms',
   url: '/terms',
   templateUrl: require('./privacy-policy.html')
};

export const privacyState = {
   parent: 'anon',
   name: 'privacy',
   url: '/privacy',
   templateUrl: require('./privacy-policy.html')
};

export const newPasswordRequestState = {
   parent: 'anon',
   name: 'newPasswordRequest',
   url: '/forgot',
   component: 'newPasswordRequest'
};

export const setPasswordState = {
   parent: 'anon',
   name: 'setPassword',
   url: '/forgot/:token',
   component: 'setPassword'
};

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider', '$urlServiceProvider'];
function configRoutes($stateRegistry:uir.StateRegistry, $urlService:uir.UrlService) {
   $stateRegistry.register(appState);
   $stateRegistry.register(adminState);
   $stateRegistry.register(anonState);
   $stateRegistry.register(loginState);
   $stateRegistry.register(termsState);
   $stateRegistry.register(privacyState);
   $stateRegistry.register(newPasswordRequestState);
   $stateRegistry.register(setPasswordState);

   $urlService.rules.otherwise({ state: 'login' });
}

// ng.module('e360').run(trace);
// trace.$inject = ['$trace'];
// function trace($trace:uir.Trace) {
//    $trace.enable();
// }
